<template>
    <div class="content">
        <div class="book-description">
            <div class="shell">
                <h2 class="h2">Valutazioni e recensioni su Book Sharing app</h2>

                <div class="book-description__entry" v-html="pageData.description"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';

export default {
    name: 'BookComment',

    setup() {
        const pageData = ref({
            description: `<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>

            <p>Put forward (someone or something) with approval as being suitable for a particular purpose or role. Rush hour, London. A packed commuter train is torn apart in a collision. Picking through the carnage, ex-special forces profiler Ziba MacKenzie helps a dying woman who passes on a cryptic message: He did it. You have to tell someone.</p>

            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>`,
        })

        return {
            pageData,
        }
    }
}
</script>
